import { useSession } from "next-auth/react";
import { SessionKf } from "components/auth/lib/SessionKf";

export function useSessionKf() {
  const auth = useSession();
  return {
    session: auth.data as SessionKf,
    status: auth.status,
  };
}
